import { __awaiter } from "tslib";
import HTMLSanitizer from '@app/services/HTMLSanitizer';
export const GLOSBE_PROVIDER_NAME = "glosbeTranslate";
let glosbeTranslatorLinkTemplate = (l1Code, l2Code, text) => `https://translate.glosbe.com/${l1Code}-${l2Code}/${encodeURIComponent(text.trim())}`;
let glosbeTranslationApiUrlTemplate = (l1Code, l2Code) => `https://translator-api.glosbe.com/translateByLangWithScore?sourceLang=${l1Code}&targetLang=${l2Code}`;
function processTranslationResults({ l1Code, l2Code, text, result }, wrapInLink) {
    if (!wrapInLink) {
        return HTMLSanitizer.escapeLtGtHtml(result.translation);
    }
    const glosbeTranslatorLink = glosbeTranslatorLinkTemplate(l1Code, l2Code, text);
    const html = HTMLSanitizer.escapeLtGtHtml(result.translation);
    return `<a href=${glosbeTranslatorLink} class="hover:underline " target="_blank">${html}</a>`;
}
export const GlosbeAutomaticTranslationProvider = (wrapInLink = false) => (_a) => __awaiter(void 0, [_a], void 0, function* ({ l1Code, l2Code, text }) {
    if (!text || text.trim().length === 0) {
        return {
            provider: GLOSBE_PROVIDER_NAME,
            request: {
                l1Code,
                l2Code,
                text
            },
            result: {
                html: '',
                text: '',
                resultRaw: '',
            }
        };
    }
    const url = glosbeTranslationApiUrlTemplate(l1Code, l2Code);
    const response = yield fetch(url, { method: "POST", body: text });
    const translationResponse = yield response.json();
    return {
        result: {
            text: translationResponse.translation,
            resultRaw: translationResponse,
            html: processTranslationResults({ l1Code, l2Code, text, result: translationResponse }, wrapInLink),
        },
        provider: GLOSBE_PROVIDER_NAME,
        request: {
            l1Code,
            l2Code,
            text
        }
    };
});
